




















import { Component, Vue, Prop, Mixins } from 'vue-property-decorator'
import {doubleNumber} from '@/utils/validate'
import widgetCommon from './widgetCommon'
import {isUndef} from '@/utils/common'
const validatorFixed = (value: string, rule: any, ) => {
    if (!value) {
      return true
    }
    if ((Number(value).toFixed(rule.decimalPoint) !== value)) {
      return false
    } else {
      return true
    }
  }
const validatorMax = (value: string, rule: any, ) => {
    if (!value) {
      return true
    }
    if (!isUndef(rule.maxNumber) && (value > rule.maxNumber)) {
      return false
    } else {
      return true
    }
  }
const validatorMin = (value: string, rule: any) => {
    if (!value) {
      return true
    }
    if (!isUndef(rule.minNumber) && (value < rule.minNumber)) {
      return false
    } else {
      return true
    }
  }
const validatorNum = (value: string, rule: any) => {
    if (!value) {
      return true
    }
    if (!doubleNumber.test(value)) {
      return false
    } else {
      return true
    }
  }
@Component({
  components: {
  }
})
export default class extends Mixins(widgetCommon) {
  private get rules () {
    let rules: any = []
    let {numberRange, maxNumber, minNumber, decimalPoint} = this.item
    rules.push({ validator: validatorNum, message: `必须为数字`, trigger: 'onBlur' })
    if (numberRange === 2) {
      rules.push({ trigger: 'onBlur', validator: validatorMax, maxNumber, message: (value, rule) =>  ('最大值不超过' + rule.maxNumber)})
      rules.push({ trigger: 'onBlur', validator: validatorMin, minNumber, message: (value, rule) =>  ('最小值不小于' + rule.minNumber)})
    }
    rules.push({ trigger: 'onBlur', validator: validatorFixed, decimalPoint, message: (value, rule) =>  ('小数点后保留' + rule.decimalPoint + '位')})
    return this.commonRule.concat(rules)
  }
  public blur () {
    let value = this.form[this.item.businessId]
    if (value && !isNaN(Number(value))) {
      this.form[this.item.businessId] = Number(value).toFixed(this.item.decimalPoint)
    } else if (value === '') {
      this.form[this.item.businessId] = ''
    }
    if (this.type === 'inCell') {
      this.$emit('fieldBlur', this.form[this.item.businessId])
    }
  }
  public initField () {
    // 添加记录，设置默认值
    if (this.isUndef(this.form[this.item.businessId]) && this.item.defaultType === 1) {
      let defaultV = this.item.defaultValue
      if (defaultV) {
        this.form[this.item.businessId] = this.resultFn(Number(defaultV))
      } else {
        this.form[this.item.businessId] = ''
      }
    }
  }
  // 对公式的计算结果处理
  public resultFn (number1: number) {
    if (typeof number1 === 'number') {
      return number1.toFixed(this.item.decimalPoint)
    }
    return number1
  }
  public mounted () {
    if (this.type.includes('record')) {
      this.initField()
    }
  }
}
